
import React, { useState } from 'react';

const brands = [
  {
    name: 'Shaw Floors',
    logo: 'https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/135c2b4cbc388025248158d96bfdfb45.png',
  },
];

export default function Brands() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section className="py-20 bg-[#F9F7F4]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-[#FF6B35] uppercase tracking-widest mb-3 block">
            Our Partners
          </span>
          <h2 className="text-3xl font-bold text-[#2C3E50] mb-4">
            We Work With the Best Brands &amp; Products
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm leading-relaxed">
            We partner with industry-leading manufacturers to deliver premium flooring solutions backed by
            quality, innovation, and lasting performance.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8">
          {brands.map((brand, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className={`
                bg-white rounded-xl shadow-sm border border-gray-100
                px-10 py-8 flex items-center justify-center cursor-pointer
                transition-all duration-300 w-52 h-32
                ${hoveredIndex === index ? 'shadow-lg border-[#FF6B35]/30 scale-105' : 'hover:shadow-md'}
              `}
            >
              <img
                src={brand.logo}
                alt={brand.name}
                title={brand.name}
                className="max-h-16 max-w-full object-contain"
                style={{
                  filter: hoveredIndex === index ? 'none' : 'grayscale(100%)',
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
